import React, { lazy } from "react";
import Loadable from "../../layout/fullLayout/loadable/loadable";
import { AuthorizedRoute } from "../../router/AuthorizedRoute";
import { CALLING_ROUTE } from "./calling.constant";
import { ALLOWED_MODULES } from "../../constants/enums";
import { exact } from "prop-types";
import { QuickCampaignData } from "./CampaignData/QuickCampaignData";
import { RightPanel } from "../../components/RightPanel";




const CampaignList = Loadable(
  lazy(() =>
    import("./Campaigns/CampaignList").then(({ CampaignList }) => ({
      default: CampaignList,
    }))
  )
);

const ManageCalling = Loadable(
  lazy(() =>
    import("./Campaigns/ManageCalling").then(({ ManageCalling }) => ({
      default: ManageCalling,
    }))
  )
);

const CampaignDataList = Loadable(
  lazy(() =>
    import("./CampaignData/CampaignDataList").then(({ CampaignDataList }) => ({
      default: CampaignDataList,
    }))
  )
);

const ManageCampaignData = Loadable(
  lazy(() =>
    import("./CampaignData/ManageCampaignData").then(
      ({ ManageCampaignData }) => ({
        default: ManageCampaignData,
      })
    )
  )
);

const BulkCampaign = Loadable(
  lazy(() =>
    import("./BulkCampaign/BulkCampaign").then(({ BulkCampaign }) => ({
      default: BulkCampaign,
    }))
  )
);



export const callingRoutes = [
 
  {
    path: `${CALLING_ROUTE}`,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[]}
      >
        <CampaignList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${CALLING_ROUTE}/manage-campaign`,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[]}
      >
        <ManageCalling />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${CALLING_ROUTE}/manage-campaign/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[]}
      >
        <ManageCalling />
      </AuthorizedRoute>
    ),
  },

 
  {
    path: `${CALLING_ROUTE}/lead-records`,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[]}
      >
        <CampaignDataList />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${CALLING_ROUTE}/manage-lead`,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[]}
      >
        <ManageCampaignData />
      </AuthorizedRoute>
    ),
  },
  {
    path: `${CALLING_ROUTE}/manage-lead/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[]}
      >
        <ManageCampaignData />
      </AuthorizedRoute>
    ),
  },

  
   {
    path: `${CALLING_ROUTE}/quick-data/:uuid`,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[]}
      >
      <RightPanel 
        open
        heading="Quickly Edit Data"
        width="80%"
        children={<QuickCampaignData />}
      />
        
      </AuthorizedRoute>
    ),
  },

  
  {
    path: `${CALLING_ROUTE}/bulk-import`,
    exact: true,
    element: (
      <AuthorizedRoute
        allowFullAccess
        moduleIds={[]}
      >
        <BulkCampaign />
      </AuthorizedRoute>
    ),
  },
];
